import { render, staticRenderFns } from "./translate_check_form.vue?vue&type=template&id=3d3134f8"
import script from "./translate_check_form.vue?vue&type=script&lang=js"
export * from "./translate_check_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports